import React, { useState } from "react";
import { IconButton, Popover, Tooltip } from "@material-ui/core";
import EventLabel2, { renderText } from "../../../../components/EventLabel2/EventLabel2";
import { eventLabelGroupsConstants } from "../../../constants/eventLabelGroups.contansts";
import Picker from "emoji-picker-react";
import MoodIcon from "@material-ui/icons/Mood";

export function ChatEmojiPicker(props) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [chosenEmoji, setChosenEmoji] = useState(null);

  const { onTyping, primaryColor, preview } = props;

  const onEmojiClick = (event, emojiObject) => {
    onTyping(emojiObject.emoji, true);
    handleClose();
  };
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    /*     <div className="emoji-addon"> */
    <>
      <IconButton disabled={preview} aria-describedby={"open-emoji-picker"} onClick={handleClick} style={{ color: primaryColor, padding: "8px" }}>
        <Tooltip title={<EventLabel2 name="SendEmoji" groupName={eventLabelGroupsConstants.CHAT_LABEL_GROUP} />}>
          <MoodIcon />
        </Tooltip>
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <Picker
          onEmojiClick={onEmojiClick}
          groupNames={{
            smileys_people: renderText("SmileyPeople", eventLabelGroupsConstants.CHAT_LABEL_GROUP),
            animals_nature: renderText("AnimalsAndNature", eventLabelGroupsConstants.CHAT_LABEL_GROUP),
            food_drink: renderText("FoodAndDrink", eventLabelGroupsConstants.CHAT_LABEL_GROUP),
            travel_places: renderText("TravelPlaces", eventLabelGroupsConstants.CHAT_LABEL_GROUP),
            activities: renderText("Activities", eventLabelGroupsConstants.CHAT_LABEL_GROUP),
            objects: renderText("Objects", eventLabelGroupsConstants.CHAT_LABEL_GROUP),
            symbols: renderText("Symbols", eventLabelGroupsConstants.CHAT_LABEL_GROUP),
            flags: renderText("Flags", eventLabelGroupsConstants.CHAT_LABEL_GROUP),
            recently_used: renderText("RecentlyUsed", eventLabelGroupsConstants.CHAT_LABEL_GROUP),
          }}
        />
      </Popover>
    </>
    /*  </div> */
  );
}
